const indexStyles = `
<style>
body {
  overflow: hidden;
  margin: 0;
  padding-left: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    text-align: left;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


button:hover {
  background-color: #45a049; /* Darker shade of green on hover */
}

.latex {
  max-width: 100%;
  text-align: center;
    margin-bottom: 5px;
}

details {
  border: 1px solid #ccc;
  max-width: 100%;
  padding: 5px 10px 5px;
  border-radius: 5px;
    margin-bottom: 10px;
}

summary {
  font-weight: bold;
  cursor: pointer;
}

summary::-webkit-details-marker {
  display: none;
}

details[open] summary ~ * {
  animation: sweep 0.5s ease-in-out;
}

.box {
    /* border: 1px solid #007BFF; /* Blue border */
    /* background-color: #f0f9ff; /* Light blue background */
    border: 1px solid #ccc;
    padding: 10px 10px 0px;
    margin-bottom: 10px;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
}

.box-title {
    font-weight: bold;
}

.box-icon {
    /* Optional: styles for an icon or emblem */
}

.mainpoint {
  margin: 10px 0;
  border: 1px solid #ccc;
}

.mainpoint-content {
  padding: 0px 10px 0px;
}

.mainpoint-title {

  padding: 5px 10px;
  font-weight: bold;
}

/* Only specify the background-color for each title color variation */
.mainpoint-title-red {
  background-color: #ff6666; /* Darker red */
}

.mainpoint-title-blue {
  background-color: #99ECF7; /* Darker blue */
}

.mainpoint-title-green {
  background-color: #66ff66; /* Darker green */
}

.mainpoint-title-purple {
  background-color: #b366ff; /* Darker purple */
}

.mainpoint-title-orange {
  background-color: #ffad33; /* Darker orange */
}

.mainpoint-title-grey {
  background-color: #d0d0d0; /* Darker grey */
}

.mainpoint-red {
    background-color: #ffcccc; /* Lighter red */
}

.mainpoint-blue {
    background-color: #CFF9FF; /* Lighter blue */
}

.mainpoint-green {
    background-color: #ccffcc; /* Lighter green */
}

.mainpoint-purple {
    background-color: #e6ccff; /* Lighter purple */
}

.mainpoint-orange {
    background-color: #ffe6cc; /* Lighter orange */
}

.mainpoint-grey {
    background-color: #f0f0f0; /* Lighter grey */
}

pre {
    background-color: #2a2d31;
    padding: 10px;
    border-radius: 5px;
    overflow-x: auto;
}

code {
    font-family: 'Courier New', monospace;
    font-size: 14px;
    color: #ffffff;
}

.hljs {
    background-color: #2a2d31;
    color: #ffffff;
}

</style>
`

export default indexStyles;